"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAccountStatus = void 0;
/* User Account Status */
var UserAccountStatus;
(function (UserAccountStatus) {
    UserAccountStatus["Active"] = "Active";
    UserAccountStatus["Expired"] = "Expired";
    UserAccountStatus["Cancelled"] = "Cancelled";
})(UserAccountStatus = exports.UserAccountStatus || (exports.UserAccountStatus = {}));
//# sourceMappingURL=account_settings_types.js.map